import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "grid gap-3 md:grid-cols-2 xl:grid-cols-4" }
const _hoisted_3 = { class: "flex items-center justify-between gap-3" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-sm font-semibold text-slate-500" }
const _hoisted_6 = { class: "mt-1 text-2xl font-black text-ink" }
const _hoisted_7 = { class: "mt-2 text-left text-[11px] text-slate-500" }
const _hoisted_8 = { class: "mt-3 grid gap-3 xl:grid-cols-[minmax(0,1.55fr)_minmax(320px,0.85fr)]" }
const _hoisted_9 = { class: "panel-pad min-w-0" }
const _hoisted_10 = { class: "grid gap-3" }
const _hoisted_11 = { class: "panel-pad min-w-0" }
const _hoisted_12 = { class: "panel-pad min-w-0" }
const _hoisted_13 = { class: "mt-3 grid gap-3 xl:grid-cols-[minmax(0,1.55fr)_minmax(320px,0.85fr)]" }
const _hoisted_14 = { class: "panel-pad min-w-0" }
const _hoisted_15 = { class: "panel-pad min-w-0" }
const _hoisted_16 = {
  key: 0,
  class: "mt-3 rounded-xl bg-rose-50 p-3 text-xs font-semibold text-rose-700"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPageHero = _resolveComponent("UiPageHero")!
  const _component_VChart = _resolveComponent("VChart")!
  const _component_ChartBox = _resolveComponent("ChartBox")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_UiPageHero, {
      eyebrow: "Dashboard",
      title: "Tổng quan tài sản",
      description: "Tổng quan thiết bị và thống kê 12 tháng."
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_UiButton, {
          variant: "white",
          icon: "refresh",
          disabled: $setup.loading,
          onClick: $setup.loadData
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.loading ? "Đang tải..." : "Làm mới"), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.statCards, (card) => {
        return (_openBlock(), _createElementBlock("article", {
          key: card.title,
          class: "panel-pad"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(card.title), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(card.value), 1)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["grid h-9 w-9 place-items-center rounded-xl", card.badge])
            }, _toDisplayString(card.short), 3)
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(card.caption), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("section", _hoisted_9, [
        _createVNode(_component_ChartBox, {
          title: "Xu hướng tài sản trong 12 tháng",
          subtitle: "So sánh tiếp nhận, hết hạn và biến động",
          class: "h-[500px]"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VChart, {
              autoresize: "",
              option: $setup.trendLineOption
            }, null, 8, ["option"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("section", _hoisted_11, [
          _createVNode(_component_ChartBox, {
            title: "Tỷ lệ tiếp nhận so với tổng thiết bị",
            class: "h-[240px]"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VChart, {
                autoresize: "",
                option: $setup.statusGaugeOption
              }, null, 8, ["option"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", _hoisted_12, [
          _createVNode(_component_ChartBox, {
            title: "Thiết bị được bàn giao theo khoa/phòng",
            subtitle: "Đơn vị có phát sinh tiếp nhận",
            class: "h-[247px]"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VChart, {
                autoresize: "",
                option: $setup.departmentDonutOption
              }, null, 8, ["option"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("section", _hoisted_14, [
        _createVNode(_component_ChartBox, {
          title: "Tiếp nhận & hết hạn",
          subtitle: "Theo từng tháng",
          class: "h-[300px]"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VChart, {
              autoresize: "",
              option: $setup.receivedExpiredBarOption
            }, null, 8, ["option"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("section", _hoisted_15, [
        _createVNode(_component_ChartBox, {
          title: "Thiết bị theo khoa/phòng",
          subtitle: "Theo khoa/phòng",
          class: "h-[300px]"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VChart, {
              autoresize: "",
              option: $setup.currentDevicePieOption
            }, null, 8, ["option"])
          ]),
          _: 1
        })
      ])
    ]),
    ($setup.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString($setup.error), 1))
      : _createCommentVNode("", true)
  ]))
}